var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaMastercardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250.883,
    height: 50,
    id: "svg841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs845"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 160.555,-7.441 h 131.39 v 86.9 h -131.39 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 196.414,5.346 h 24.065 V 44.65 h -24.065 z",
    fill: "#ff5f00",
    id: "path835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 198.893,25.001 a 24.953,24.953 0 0 1 9.547,-19.648 24.995,24.995 0 1 0 0,39.305 24.953,24.953 0 0 1 -9.547,-19.656 z",
    fill: "#eb001b",
    id: "path837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 246.495,40.491 v -0.805 h 0.347 v -0.167 h -0.826 v 0.167 h 0.326 v 0.805 z m 1.604,0 v -0.972 h -0.25 l -0.292,0.694 -0.292,-0.694 h -0.25 v 0.972 h 0.181 v -0.736 l 0.271,0.632 h 0.187 l 0.271,-0.632 v 0.736 z m 0.784,-15.49 a 24.995,24.995 0 0 1 -40.443,19.649 24.995,24.995 0 0 0 0,-39.305 24.995,24.995 0 0 1 40.443,19.649 z",
    fill: "#f79e1b",
    id: "path839"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 69.247867,5.071683 -9.061,41.587 h -10.958 l 9.061,-41.587 z m 46.104003,26.854 5.769,-15.618 3.318,15.618 z m 12.232,14.733 h 10.133 l -8.853,-41.587 h -9.348 c -2.107,0 -3.882,1.199 -4.668,3.049 l -16.444,38.539 h 11.509 l 2.285,-6.21 h 14.058 z m -28.609,-13.577 c 0.049,-10.975 -15.453,-11.583 -15.35,-16.487 0.034,-1.49 1.481,-3.078 4.646,-3.483 1.57,-0.199 5.899,-0.359 10.808,1.861 l 1.92,-8.823 c -2.637,-0.936 -6.029,-1.838 -10.25,-1.838 -10.834,0 -18.455,5.6489999 -18.516,13.746 -0.069,5.987 5.444,9.325 9.589,11.319 4.274,2.038 5.707,3.346 5.686,5.167 -0.03,2.79 -3.409,4.025 -6.554,4.072 -5.514,0.084 -8.708,-1.463 -11.255003,-2.628 l -1.989,9.117 c 2.564,1.153 7.290003,2.156 12.183003,2.207 11.517,0 19.048,-5.584 19.082,-14.23 z m -45.386003,-28.01 -17.756,41.587 h -11.583 l -8.739,-33.19 c -0.529,-2.041 -0.991,-2.791 -2.602,-3.6530001 -2.635,-1.4059999 -6.986,-2.7199999 -10.811,-3.5379999 l 0.258,-1.207 h 18.648 c 2.375,0 4.512,1.552 5.055,4.238 l 4.616,24.067 11.4,-28.305 z",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "use852"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaMastercardLogo);
export default __webpack_public_path__ + "static/media/visa-mastercard-logo.b5f3a629580ffea8a90cc764226ed2e7.svg";
export { ForwardRef as ReactComponent };